<template>
    <div v-if="which_to_show">
        <!--        <div>组件测试</div>-->
        <!--        <button @click='toShow'>点击显示子组件</button>-->
        <!--        <div>{{which_to_show}}</div>-->
        <component v-bind:is="which_to_show" style=""></component>
    </div>
</template>

<script>
    // import Wp_jd_select from "../pages/Wp_jd_select";
    // import Wp_jd_changelink from "../pages/Wp_jd_changelink";
    // import Wp_jd_events from "../pages/Wp_jd_events";
    // import Wp_jd_data from "../pages/Wp_jd_data";
    // import Wp_jd_my from "../pages/Wp_jd_my";

    import {Toast} from "vant";

    export default {
        name: "Wp_hm_config",

        components: {
            // Wp_jd_my,
            // Wp_jd_data,
            // Wp_jd_events,
            // Wp_jd_select,
            // Wp_jd_changelink,
            'Wp_jd_select': () => import('../pages/Wp_jd_select'),
            'Wp_jd_changelink': () => import('../pages/Wp_jd_changelink'),
            'Wp_jd_events': () => import('../pages/Wp_jd_events'),
            'Wp_jd_data': () => import('../pages/Wp_jd_data'),
            'Wp_order_count': () => import('../pages_childs/Wp_order_count'),
            'Wp_jd_order_flow': () => import('../pages/Wp_jd_order_flow'),
            'Wp_my_child_member': () => import('../pages_childs/Wp_my_child_member'),
            'Wp_jd_my': () => import('../pages/Wp_jd_my'),
            'Wp_my_pay_data': () => import('../pages_childs/Wp_my_pay_data'),

            'Wp_mini_my': () => import('../pages_mini_app/Wp_mini_my'),
            'Wp_mini_login': () => import('../pages_mini_app/Wp_mini_login'),
            'Wp_mini_event': () => import('../pages_mini_app/Wp_mini_event'),
            'Wp_mini_member': () => import('../pages_mini_app/Wp_mini_member'),
            'Wp_mini_guide': () => import('../pages_mini_app/Wp_mini_guide'),
            'Wp_mini_upgrade': () => import('../pages_mini_app/Wp_mini_upgrade'),
            'Wp_mini_home': () => import('../pages/Wp_jd_home'),
            'Wp_jd_action_info': () => import('../pages_childs/Wp_jd_action_info'),
            'Wp_search_page': () => import('../pages_childs/Wp_search_page'),
            'Wp_wx_public_regist': () => import('../pages_wx_public/Wp_wx_public_regist'),
        },

        data() {
            return {
                which_to_show: ''
            }
        },

        created() {
            // if(this.isHema()){
            //     this.$log("------当前为【hema】的链接")
            //
            //     this.showPage();
            // }
            const toast = Toast.loading({
                duration: 0, // 持续展示 toast
                forbidClick: true,
                message: '加载中...'
            });

            let openid = this.$common.getUrlKey("openid");
            if (!openid) {
                toast.clear();
                this.showPage();
            } else {
                this.$common.gloabl_wx_openid = openid;
                //根据openid从服务器获取微信用户信息
                this.$getGloabl_WxUserinfo(openid, () => {
                    toast.clear();
                    let userInfo = this.$common.gloabl_wx_mini_user_info;
                    if(userInfo){
                        let user = {
                            username: userInfo.channel_name,
                            // userId: loginInfo.id,
                            pid: userInfo.channel_id,
                            // alipay: loginInfo.u_alpay,//支付宝账号
                            // bankName: loginInfo.u_bank,//开户行
                            // cardNomber: loginInfo.u_card,//银行卡号
                            // bank_account: loginInfo.u_bank_account,// 账号名称
                            openid: openid,//微信openid
                            // truename: loginInfo.u_payname,// 真实姓名
                            // userType: loginInfo.u_type,// 0群主1代理商
                        };
                        this.$store.commit('login', user);

                        //获取数据后，不论成功还是失败，都跳转界面
                        this.showPage();
                    }else{
                        if(this.$store.state.username && this.$store.state.pid){
                            this.$common.gloabl_wx_mini_login_status = 'super';
                            this.showPage();
                        }else{
                            let _url = window.location.href;
                            this.$log("_url = " + _url)
                            // this.$router.push('login?url=' + encodeURIComponent(_url));
                            this.$router.replace('login?url=' + encodeURIComponent(_url));
                        }
                    }

                });
                // this.showPage();
            }
        },

        methods: {
            isHema() {
                return this.$common.isHema();
            },

            showPage() {
                // let url = window.location.href;
                // this.$log(url)
                let param_page = this.$common.getUrlKey("p");
                this.$log("param_page = " + param_page)

                if (param_page === "select") {
                    this.which_to_show = "Wp_jd_select";
                    // this.which_to_show = this.components.Wp_jd_select;
                } else if (param_page === "changelink") {
                    this.which_to_show = "Wp_jd_changelink";
                } else if (param_page === "events") {
                    this.which_to_show = "Wp_jd_events";
                } else if (param_page === "data") {
                    this.which_to_show = "Wp_jd_data";
                } else if (param_page === "data1") {
                    this.which_to_show = "Wp_order_count";
                } else if (param_page === "data2") {
                    this.which_to_show = "Wp_jd_order_flow";
                } else if (param_page === "data3") {
                    this.which_to_show = "Wp_my_child_member";
                } else if (param_page === "my") {
                    this.which_to_show = "Wp_jd_my";
                } else if (param_page === "paydata") {
                    this.which_to_show = "Wp_my_pay_data";
                }  else if (param_page === "mini_my") {
                    this.which_to_show = "Wp_mini_my";
                } else if (param_page === "mini_login") {
                    this.which_to_show = "Wp_mini_login";
                } else if (param_page === "mini_event") {
                    this.which_to_show = "Wp_mini_event";
                } else if (param_page === "mini_member") {
                    this.which_to_show = "Wp_mini_member";
                } else if (param_page === "mini_guide") {
                    this.which_to_show = "Wp_mini_guide";
                } else if (param_page === "mini_upgrade") {
                    this.which_to_show = "Wp_mini_upgrade";
                }else if (param_page === "home") {
                    this.which_to_show = "Wp_mini_home";
                }else if (param_page === "action_info") {

                    let act = this.$common.getUrlKey("act");
                    if(act){
                        this.act_params = {
                            actId: act,
                        }
                    }
                    this.which_to_show = "Wp_jd_action_info";

                }else if (param_page === "search_page") {
                    this.which_to_show = "Wp_search_page";
                }else if (param_page === "wx_public_regist") {
                    this.which_to_show = "Wp_wx_public_regist";
                }else {
                    this.which_to_show = "Wp_jd_select";
                }
            },

            toShow() {
                let arr = ["first", "Wp_jd_select", "Wp_jd_my"];
                let index = arr.indexOf(this.which_to_show);
                if (index < 2) {
                    this.which_to_show = arr[index + 1];
                } else {
                    this.which_to_show = arr[0];
                }
            }
        }
    }
</script>

<style scoped>

</style>